export const getAllScheduledRegions = (schedules, type = null) => {
  const allSelectedRegions = [...schedules]
    .filter((el) => type && el.type === type && el.brand === 'luxuryescapes')
    .map((el) => el.region);
  return [...new Set(allSelectedRegions)];
};
